// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button_btn__vunuk {
  width: 100%;
  height: 44px;
  border-radius: 12px;
  background-color: var(--accent-color);
  transition: 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  color: var(--accent-text-color);
  font-size: var(--fz-sm);
  font-style: normal;
  font-weight: 600;
  line-height: 1;
  position: relative;
}
@media (hover: hover) {
  .Button_btn__vunuk:hover {
    opacity: 0.8;
  }
}
@media (min-width: 640px) {
  .Button_btn__vunuk {
    font-size: 20px;
    height: 76px;
  }
}
@media (min-width: 1200px) {
  .Button_btn__vunuk {
    font-size: var(--fz-sm);
    width: auto;
    height: 36px;
    padding-left: 32px;
    padding-right: 32px;
  }
}
.Button_btn__vunuk:disabled {
  cursor: default;
  pointer-events: none;
  background-color: #EEEEEE;
  color: rgba(21, 27, 38, 0.4);
}
.Button_btn__loader__\\+uKER, .Button_btn__icon__xBrgk {
  position: absolute;
  transform: translateY(-50%);
  right: 12px;
  width: 16px;
  height: 16px;
  transform-origin: center;
}
.Button_btn__loader__\\+uKER {
  top: 50%;
  animation: Button_loader__OTTvr 2s infinite linear;
}
.Button_btn__loader__\\+uKER + .Button_btn__icon__xBrgk {
  display: none;
}
.Button_btn__icon__xBrgk {
  top: calc(50% + 2px);
}
@media (min-width: 1200px) {
  .Button_btn__icon__xBrgk {
    display: flex;
  }
}
.Button_btn--is-loading__h4d9N {
  pointer-events: none;
}
.Button_btn--gray__Hb9H7 {
  background: #EEEEEE;
  color: var(--text-color);
}
.Button_btn--warning__HsKZK {
  background: linear-gradient(87.49deg, #FA7B45 -0.07%, #F44C4C 95.73%);
}
.Button_btn--white__6Nytw {
  background-color: var(--white);
  color: var(--text-color);
}
@media (hover: hover) {
  .Button_btn--white__6Nytw:hover {
    background-color: var(--accent-color);
    color: var(--accent-text-color);
  }
}
.Button_btn--light__yfHtg {
  background-color: rgba(var(--accent-color-rgb), 0.12);
  color: var(--accent-color);
}
@media (hover: hover) {
  .Button_btn--light__yfHtg:hover {
    background-color: var(--accent-color);
    color: var(--accent-text-color);
  }
}
.Button_btn--sm-width__sRBFQ {
  width: 94px;
  min-width: 94px;
}
.Button_btn--sm__u5cjO {
  height: 32px;
}
@media (min-width: 1200px) {
  .Button_btn--sm__u5cjO {
    padding-left: 16px;
    padding-right: 16px;
  }
}
.Button_btn--md__\\+5ffY {
  height: 66px;
}
@media (min-width: 640px) {
  .Button_btn--md__\\+5ffY {
    height: 76px;
    font-size: 20px;
  }
}
@media (min-width: 1200px) {
  .Button_btn--md__\\+5ffY {
    height: 44px;
    font-size: 12px;
    line-height: normal;
  }
}
.Button_btn--xsm__o9krP {
  height: 44px;
  border-radius: 12px;
  padding-left: 18px;
  padding-right: 18px;
}
@media (min-width: 1200px) {
  .Button_btn--xsm__o9krP {
    height: 28px;
    border-radius: 6px;
    line-height: normal;
  }
}

@keyframes Button_loader__OTTvr {
  0% {
    transform: translateY(-50%) rotate(0deg);
  }
  0% {
    transform: translateY(-50%) rotate(360deg);
  }
  100% {
    transform: translateY(-50%) rotate(0deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Assets/Button/Button.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,+BAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AACF;AACE;EACE;IACE,YAAA;EACJ;AACF;AAEE;EAvBF;IAwBI,eAAA;IACA,YAAA;EACF;AACF;AACE;EA5BF;IA6BI,uBAAA;IACA,WAAA;IACA,YAAA;IACA,kBAAA;IACA,mBAAA;EAEF;AACF;AAAE;EACE,eAAA;EACA,oBAAA;EACA,yBAAA;EACA,4BAAA;AAEJ;AACE;EAEE,kBAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;AAAJ;AAGE;EACE,QAAA;EACA,kDAAA;AADJ;AAIM;EACE,aAAA;AAFR;AAOE;EACE,oBAAA;AALJ;AAOI;EAHF;IAII,aAAA;EAJJ;AACF;AAOE;EACE,oBAAA;AALJ;AAQE;EACE,mBAAA;EACA,wBAAA;AANJ;AASE;EACE,qEAAA;AAPJ;AAUE;EACE,8BAAA;EACA,wBAAA;AARJ;AAUI;EACE;IACE,qCAAA;IACA,+BAAA;EARN;AACF;AAYE;EACE,qDAAA;EACA,0BAAA;AAVJ;AAYI;EACE;IACE,qCAAA;IACA,+BAAA;EAVN;AACF;AAcE;EACE,WAAA;EACA,eAAA;AAZJ;AAeE;EACE,YAAA;AAbJ;AAeI;EAHF;IAII,kBAAA;IACA,mBAAA;EAZJ;AACF;AAeE;EACE,YAAA;AAbJ;AAeI;EAHF;IAII,YAAA;IACA,eAAA;EAZJ;AACF;AAcI;EARF;IASI,YAAA;IACA,eAAA;IACA,mBAAA;EAXJ;AACF;AAcE;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAZJ;AAcI;EANF;IAOI,YAAA;IACA,kBAAA;IACA,mBAAA;EAXJ;AACF;;AAeA;EACE;IACE,wCAAA;EAZF;EAcA;IACE,0CAAA;EAZF;EAcA;IACE,wCAAA;EAZF;AACF","sourcesContent":[".btn {\r\n  width: 100%;\r\n  height: 44px;\r\n  border-radius: 12px;\r\n  background-color: var(--accent-color);\r\n  transition: 0.2s;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 12px 16px;\r\n  color: var(--accent-text-color);\r\n  font-size: var(--fz-sm);\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 1;\r\n  position: relative;\r\n\r\n  @media (hover: hover) {\r\n    &:hover {\r\n      opacity: 0.8;\r\n    }\r\n  }\r\n\r\n  @media (min-width: 640px) {\r\n    font-size: 20px;\r\n    height: 76px;\r\n  }\r\n\r\n  @media (min-width: 1200px) {\r\n    font-size: var(--fz-sm);\r\n    width: auto;\r\n    height: 36px;\r\n    padding-left: 32px;\r\n    padding-right: 32px;\r\n  }\r\n\r\n  &:disabled {\r\n    cursor: default;\r\n    pointer-events: none;\r\n    background-color: #EEEEEE;\r\n    color: rgba(#151B26, 0.4)\r\n  }\r\n\r\n  &__loader,\r\n  &__icon {\r\n    position: absolute;\r\n    transform: translateY(-50%);\r\n    right: 12px;\r\n    width: 16px;\r\n    height: 16px;\r\n    transform-origin: center;\r\n  }\r\n\r\n  &__loader {\r\n    top: 50%;\r\n    animation: loader 2s infinite linear;\r\n\r\n    & + .btn {\r\n      &__icon {\r\n        display: none;\r\n      }\r\n    }\r\n  }\r\n\r\n  &__icon {\r\n    top: calc(50% + 2px);\r\n\r\n    @media (min-width: 1200px) {\r\n      display: flex;\r\n    }\r\n  }\r\n\r\n  &--is-loading {\r\n    pointer-events: none;\r\n  }\r\n\r\n  &--gray {\r\n    background: #EEEEEE;\r\n    color: var(--text-color);\r\n  }\r\n\r\n  &--warning {\r\n    background: linear-gradient(87.49deg, #FA7B45 -0.07%, #F44C4C 95.73%);\r\n  }\r\n\r\n  &--white {\r\n    background-color: var(--white);\r\n    color: var(--text-color);\r\n\r\n    @media (hover: hover) {\r\n      &:hover {\r\n        background-color: var(--accent-color);\r\n        color: var(--accent-text-color);\r\n      }\r\n    }\r\n  }\r\n\r\n  &--light {\r\n    background-color: rgba(var(--accent-color-rgb), 0.12);\r\n    color: var(--accent-color);\r\n\r\n    @media (hover: hover) {\r\n      &:hover {\r\n        background-color: var(--accent-color);\r\n        color: var(--accent-text-color);\r\n      }\r\n    }\r\n  }\r\n\r\n  &--sm-width {\r\n    width: 94px;\r\n    min-width: 94px;\r\n  }\r\n\r\n  &--sm {\r\n    height: 32px;\r\n\r\n    @media (min-width: 1200px) {\r\n      padding-left: 16px;\r\n      padding-right: 16px;\r\n    }\r\n  }\r\n\r\n  &--md {\r\n    height: 66px;\r\n\r\n    @media (min-width: 640px) {\r\n      height: 76px;\r\n      font-size: 20px;\r\n    }\r\n\r\n    @media (min-width: 1200px) {\r\n      height: 44px;\r\n      font-size: 12px;\r\n      line-height: normal;\r\n    }\r\n  }\r\n\r\n  &--xsm {\r\n    height: 44px;\r\n    border-radius: 12px;\r\n    padding-left: 18px;\r\n    padding-right: 18px;\r\n\r\n    @media (min-width: 1200px) {\r\n      height: 28px;\r\n      border-radius: 6px;\r\n      line-height: normal;\r\n    }\r\n  }\r\n}\r\n\r\n@keyframes loader {\r\n  0% {\r\n    transform: translateY(-50%) rotate(0deg);\r\n  }\r\n  0% {\r\n    transform: translateY(-50%) rotate(360deg);\r\n  }\r\n  100% {\r\n    transform: translateY(-50%) rotate(0deg);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn": `Button_btn__vunuk`,
	"btn__loader": `Button_btn__loader__+uKER`,
	"btn__icon": `Button_btn__icon__xBrgk`,
	"loader": `Button_loader__OTTvr`,
	"btn--is-loading": `Button_btn--is-loading__h4d9N`,
	"btn--gray": `Button_btn--gray__Hb9H7`,
	"btn--warning": `Button_btn--warning__HsKZK`,
	"btn--white": `Button_btn--white__6Nytw`,
	"btn--light": `Button_btn--light__yfHtg`,
	"btn--sm-width": `Button_btn--sm-width__sRBFQ`,
	"btn--sm": `Button_btn--sm__u5cjO`,
	"btn--md": `Button_btn--md__+5ffY`,
	"btn--xsm": `Button_btn--xsm__o9krP`
};
export default ___CSS_LOADER_EXPORT___;
